module.exports = __webpack_public_path__ + "assets/delete.938b45bb.svg";